import assert from 'assert-ts';
import type {Schemas} from '../dto.generated';
import type {SearchSchemas} from '../search.dto.generated';

export const mapAgentDocumentToAgentDto = (
  dto: SearchSchemas.AgentDocument,
):
  | Schemas.AgentPersonDto
  | Schemas.AgentCorporationDto
  | Schemas.AgentEventDto
  | Schemas.AgentPublisherDto => {
  switch (dto.agentType) {
    case 'PERSON': {
      const agent: Schemas.AgentPersonDto = {
        ...dto.agentPersonData,
        ...dto,
        agentType: 'PERSON',
        externalComments: dto.notes,
        internalComments: dto.internalNotes,
        gender: dto.agentPersonData?.gender ?? 'u',
        occupationalField: dto.agentPersonData?.occupationalFields,
        pseudonym: dto.agentPersonData?.isPseudonym,
        nameVariants: (dto.agentNames ?? []).map(n => ({
          ...n,
          nameOrder: assert(
            n.nameOrder,
            'mapAgentSearchToAgentDto: Expected nameOrder',
            n,
          ),
        })),
        works: [],
        expressions: [],
        workRelations: [],
        agentPersonRelations: [],
      };

      return agent;
    }
    case 'CORPORATION': {
      const agent: Schemas.AgentCorporationDto = {
        ...dto.agentCorporationData,
        ...dto,
        agentType: 'CORPORATION',
        externalComments: dto.notes,
        internalComments: dto.internalNotes,
        nameVariants: (dto.agentNames ?? []).map(n => ({
          ...n,
          nameOrder: assert(
            n.nameOrder,
            'mapAgentSearchToAgentDto: Expected nameOrder',
            n,
          ),
        })),
        works: [],
        expressions: [],
        workRelations: [],
        agentCorporationRelations: [],
      };

      return agent;
    }
    case 'EVENT': {
      const agent: Schemas.AgentEventDto = {
        ...dto.agentEventData,
        ...dto,
        agentType: 'EVENT',
        externalComments: dto.notes,
        internalComments: dto.internalNotes,
        nameVariants: (dto.agentNames ?? []).map(n => ({
          ...n,
          nameOrder: assert(
            n.nameOrder,
            'mapAgentSearchToAgentDto: Expected nameOrder',
            n,
          ),
        })),
        works: [],
        expressions: [],
        workRelations: [],
      };

      return agent;
    }
    case 'PUBLISHER': {
      const agent: Schemas.AgentPublisherDto = {
        ...dto.agentPublisherData,
        ...dto,
        agentType: 'PUBLISHER',
        externalComments: dto.notes,
        internalComments: dto.internalNotes,
        nameVariants: (dto.agentNames ?? []).map(n => ({
          ...n,
          nameOrder: assert(
            n.nameOrder,
            'mapAgentSearchToAgentDto: Expected nameOrder',
            n,
          ),
        })),
        works: [],
        expressions: [],
        workRelations: [],
      };

      return agent;
    }
  }

  assert(false, 'mapAgentSearchToAgentDto: Unknown agentType', dto);
};
